import React from "react";
import { Grid, Divider, Box } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputCheckboxMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui";
import { TYPE_INSTANCE2 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { getByFilterPenjualanExport, RESET_STATE_FORM_FILTER } from "./helpers";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useSelector } from "react-redux";

export default function FormFilterDaftarPenjualan({
  formFilter,
  setFormFilter,
  setNewData,
  withExportButton = false,
  alwaysLunas,
  resetPagination,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);
  const { master } = useSelector((state) => state);
  const poliklinik = master.poliklinik.list_select;
  const handleChange = (text) => (e) => {
    if (text === "kategori_pencarian") {
      if (e.target.value === "0" || e.target.value === 0) {
        return setFormFilter({
          ...formFilter,
          kata_kunci: "",
          [text]: e.target.value,
        });
      }
    }
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData(1, 10);
    resetPagination();
  };

  const kelasKunjungan = useSelectOption(
    true,
    "/registration/kelaskunjungan/listkelaskunjungan",
    TYPE_INSTANCE2
  );

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterPenjualanExport(formFilter);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputOptionMaster
              name="kategori_pencarian"
              label="KATEGORI PENCARIAN"
              id="kategori_pencarian"
              withSearch={false}
              value={formFilter.kategori_pencarian}
              onChange={handleChange("kategori_pencarian")}
              data={[
                {
                  value: 0,
                  label: "Semua",
                },
                {
                  value: 1,
                  label: "ID Kunjungan",
                },
                {
                  value: 2,
                  label: "ID Penjualan",
                },
                {
                  value: 3,
                  label: "ID RM",
                },
                {
                  value: 4,
                  label: "Nama RM",
                },
              ]}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="kata_kunci"
              label="KATA KUNCI"
              id="kata_kunci"
              value={formFilter.kata_kunci}
              onChange={handleChange("kata_kunci")}
              placeholder="KATA KUNCI"
              disabled={
                formFilter.kategori_pencarian === 0 ||
                formFilter.kategori_pencarian === "0" ||
                !formFilter.kategori_pencarian
                  ? true
                  : false
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="kelas_id"
              label="KELAS KUNJUNGAN"
              id="kelas_id"
              withSearch={true}
              data={kelasKunjungan}
              value={formFilter.kelas_id}
              labelValue={formFilter.kelas_name}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  kelas_id: e?.value,
                  kelas_name: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="id_poliklinik"
              label="POLIKLINIK"
              id="id_poliklinik"
              withSearch={true}
              data={poliklinik}
              labelValue={formFilter.nama_poliklinik}
              value={formFilter.id_poliklinik}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    id_poliklinik: null,
                    nama_poliklinik: "Pilih Poliklinik",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    id_poliklinik: e.value,
                    nama_poliklinik: e.label,
                  });
                }
              }}
            >
              <div
                style={{
                  cursor: "pointer",
                  marginTop: "-3.9rem",
                  position: "absolute",
                  right: "2rem",
                }}
              >
                <InputCheckboxMaster
                  checked={formFilter.isExternal}
                  name="isExternal"
                  id="isExternal"
                  label="External"
                  onChange={() =>
                    setFormFilter({
                      ...formFilter,
                      isExternal: !formFilter.isExternal,
                    })
                  }
                />
              </div>
            </InputOptionMaster>
          </Grid>
          {!alwaysLunas && (
            <Grid item sm={3}>
              <InputOptionMaster
                name="status_pelunasan"
                label="STATUS PELUNASAN"
                id="status_pelunasan"
                withSearch={false}
                value={formFilter.status_pelunasan}
                onChange={handleChange("status_pelunasan")}
                data={[
                  {
                    value: "",
                    label: "Semua",
                  },
                  {
                    value: 0,
                    label: "Lunas",
                  },
                  {
                    value: 1,
                    label: "Tidak Lunas",
                  },
                ]}
              />
            </Grid>
          )}

          <Grid item sm={3}>
            <InputOptionMaster
              name="is_jurnal"
              label="STATUS JURNAL"
              id="is_jurnal"
              withSearch={false}
              value={formFilter.is_jurnal}
              onChange={handleChange("is_jurnal")}
              data={[
                {
                  value: 0,
                  label: "Semua",
                },
                {
                  value: 1,
                  label: "Sudah Terupdate",
                },
                {
                  value: 2,
                  label: "Belum Terupdate",
                },
              ]}
            />
          </Grid>

          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.tglAwal}
              label="TANGGAL AWAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.tglAkhir}
              label="TANGGAL AKHIR"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                })
              }
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <Box sx={{ display: "flex", gap: "16px" }}>
            {withExportButton && (
              <>
                <MasterButton
                  type={"button"}
                  color="primary-cyan"
                  name={"Export List"}
                  size="md"
                  onClick={() => setShowModalExportList(!showModalExportList)}
                />
                <MasterButton
                  type={"button"}
                  color="warning"
                  name={isLoading ? "Loading..." : "EXPORT"}
                  disabled={isLoading}
                  size="md"
                  onClick={handleExport}
                />
              </>
            )}
            <MasterButton
              name={"CARI"}
              type="submit"
              outline={true}
              color={"green"}
              size={"md"}
            />
          </Box>
        </Grid>
        <br />
      </form>
      <Divider />

      {showModalExportList && (
        <ModalExportList
          title={"Export List Penjualan"}
          showModal={() => setShowModalExportList(false)}
          type="penjualan"
        />
      )}
    </>
  );
}
